<template>
	<div>
		<p class="drawer-subtitle">
			<span class="drawer-subtitle-text">{{ getComplaintTitle() }}</span>
			<span class="complaint-alert">
				<i class="el-icon-warning complaint-alert-icon"></i>
				{{ getComplaintExpire() }}
			</span>
		</p>
		<div class="complaint-box">
			<el-form :model="complaint" :rules="complaintRules" ref="complaint" label-width="80px">
				<el-form-item label="投诉账号" prop="account">
					<el-select size="small" style="width: 350px;" v-model="complaint.account" placeholder="请选择账号">
						<el-option v-for="item in accounts" :key="item.id" :label="item.title + ':' + item.username"
							:value="item.id">
						</el-option>
					</el-select>
					<span class="complaint-box-btn" @click="onEditOrAddAccount(1)">更新cookie</span>
					<span>
						<el-popover placement="top" :value="visible" width="160">
							<p>确定删除此账号吗？</p>
							<div style="text-align: right; margin: 0">
								<el-button type="primary" size="mini" @click="onDeleteAccount">确定</el-button>
							</div>
							<div slot="reference" class="complaint-box-btn" @click="visible = true">
								删除
							</div>
						</el-popover>
					</span>
					<span class="complaint-box-btn" @click="onEditOrAddAccount(2)">添加投诉账号</span>
					<span class="complaint-box-btn" @click="jump()">知识产权平台</span>
				</el-form-item>
				<el-form-item label="所属平台" v-if="platform === 'TB'" prop="platform">
					<el-select size="small" style="width: 350px;" v-model="complaint.platform" placeholder="请选择平台">
						<el-option v-for="item in platforms" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="日期范围" required>
					<el-date-picker style="width: 350px;" size="small" value-format="yyyy-MM-dd"
						v-model="complaint.committime" type="daterange" range-separator="~" start-placeholder="开始日期"
						end-placeholder="结束日期" :picker-options="pickerOptions">
					</el-date-picker>
					<el-button type="primary" size="small" class="complaint-box-dbtn" @click="onCommit"
						:loading="onCommitLoading">导出投诉报表</el-button>
				</el-form-item>
				<el-form-item label="报表内容" prop="type" v-if="platform === 'TB' || platform === 'PDD'">
					<el-radio-group v-model="complaint.type">
						<el-radio label="only">仅投诉链接信息</el-radio>
						<!-- <el-radio label="all">含申诉材料信息</el-radio> -->
					</el-radio-group>
					<span style="color: #999;display: block;">下载申诉材料时间较长,根据下载数据的日期范围,可能需要30-60分钟,如需下载,请耐心等待</span>
				</el-form-item>
			</el-form>
		</div>
		<el-dialog :title="isEdit ? '更新Cookie' : '添加投诉账号'" :visible.sync="addOrUpdateCookieDialog"
			:close-on-click-modal="false" width="640px">
			<el-row style="box-sizing: border-box;max-height: 595px;overflow:auto;">
				<div class="seaerch-wrapper">
					<el-form :model="cookie" :rules="rules" ref="cookie" label-width="100px">
						<el-form-item label="名称" prop="title">
							<el-input v-model="cookie.title" size="small" clearable></el-input>
						</el-form-item>
						<el-form-item label="账号" prop="username">
							<el-input v-model="cookie.username" size="small" clearable></el-input>
						</el-form-item>
						<el-form-item label="密码" prop="password">
							<el-input v-model="cookie.password" size="small" clearable></el-input>
						</el-form-item>
						<el-form-item label="Cookie" prop="cookie">
							<el-input v-model="cookie.cookie" size="small" clearable></el-input>
						</el-form-item>
					</el-form>
				</div>
			</el-row>
			<span slot="footer">
				<el-button size="small" class="g-confirm-btn" @click="onCommitAccount">确 定</el-button>
				<el-button size="small" class="g-cancel-btn" @click="addOrUpdateCookieDialog = false">取 消</el-button>
			</span>
		</el-dialog>
		<el-dialog title="提示" :visible.sync="deleteAccount" width="30%">
			<div class="complaint-hint-box">
				<i class="el-icon-warning complaint-hint-icon"></i>
				<span>你确认要删除该投诉账号吗?</span>
			</div>
			<span slot="footer">
				<el-button size="small" class="g-confirm-btn" @click="deleteAccount = false">确 定</el-button>
				<el-button size="small" class="g-cancel-btn" @click="deleteAccount = false">取 消</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>

export default {
	name: 'ComplaintBox',

	components: {},

	props: {
		platform: {
			type: String,
			required: true
		}
	},

	data() {
		return {
			onCommitLoading: false,
			pickerOptions: {
				shortcuts: [
					{
						text: '今日',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
							picker.$emit('pick', [start, start]);
						}
					}, {
						text: '近7日',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '近15日',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '近30日',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: "近90日",
						onClick: picker => {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '近365日',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 364);
							picker.$emit('pick', [start, end]);
						}
					}
				]
			},
			visible: false,
			platforms: [
				{ value: 'taobao', label: '淘宝' },
				{ value: 'tmall', label: '天猫' },
				{ value: 'tmallhk', label: '天猫国际' },
				{ value: 'cbu', label: '1688' },
				{ value: 'XY', label: '闲鱼' },
				{ value: 'sc', label: 'Alibaba.com' },
				{ value: 'ae', label: 'Aliexpress' },
				{ value: 'sg', label: 'lazda' },
			],
			accounts: [],
			isEdit: false,
			addOrUpdateCookieDialog: false,
			cookie: {},
			complaintRules: {
				account: [
					{ required: true, message: '请选择账号', trigger: 'blur' },
				],
				type: [
					{ required: true, message: '请输入报表类型', trigger: 'blur' },
				],
				platform: [
					{ required: true, message: '请选择平台', trigger: 'blur' },
				],
				date1: [
					{ type: 'date', required: true, message: '请选择日期', trigger: 'change' }
				],
			},
			rules: {
				title: [
					{ required: true, message: '请输入名称', trigger: 'blur' },
				],
				username: [
					{ required: true, message: '请输入账号', trigger: 'blur' },
				],
				password: [
					{ required: true, message: '请输入密码', trigger: 'blur' },
				],
				cookie: [
					{ required: true, message: '请输入Cookie', trigger: 'blur' },
				],
			},
			deleteAccount: false,
			complaint: {
				committime: []
			},
		}
	},
	methods: {
		jump() {
			if (this.platform === 'TB') {
				window.open('https://qinquan.taobao.com/', '_blank');
			}
			if (this.platform === 'JD') {
				window.open('https://jdgroupip.com/index.html', '_blank');
			}
			if (this.platform === 'SN') {
				window.open('https://ipp.suning.com/sips//propertyPerson/index.action', '_blank');
			}
			if (this.platform === 'PDD') {
				window.open('https://ipp.pinduoduo.com/cpp/index', '_blank');
			}
			if (this.platform === 'DY') {
				window.open('https://ippro.bytedance.com/view/claim/list', '_blank');
			}
		},
		getRequestUrl() {
			if (this.platform === 'TB' && this.complaint.type === 'only') {
				return 'hcm/spider/list/taobao_tousu_List';
			}
			if (this.platform === 'TB' && this.complaint.type === 'all') {
				return 'hcm/spider/list/taobao_tousucail_List'
			}
			if (this.platform === 'JD') {
				return 'hcm/spider/list/jd_list';
			}
			if (this.platform === 'DY') {
				return 'hcm/spider/list/dy_list';
			}
			if (this.platform === 'SN') {
				return 'hcm/spider/list/sn_list';
			}
			if (this.platform === 'PDD' && this.complaint.type === 'all') {
				return 'hcm/spider/list/pdd_tousucail_List';
			}
			if (this.platform === 'PDD' && this.complaint.type === 'only') {
				return 'hcm/spider/list/pdd_list';
			}
		},
		onCommit() {
			if (!this.complaint.account) {
				this.$message.warning('请选择投诉账号');
				return;
			}
			if (this.platform === 'TB' && !this.complaint.platform) {
				this.$message.warning('请选择平台');
				return;
			}
			if (!this.complaint.committime.length) {
				this.$message.warning('请选择时间范围');
				return;
			}
			if ((this.platform === 'PDD' || this.platform === 'TB') && !this.complaint.type) {
				this.$message.warning('请选择导出报表类型');
				return;
			}
			this.onCommitLoading = true
			let account = this.accounts.find(account => {
				return account.id === this.complaint.account;
			});
			let data = {
				bmcid: localStorage.getItem('bmcKefuid'),
				gmtCreateStart: this.complaint.committime[0],
				gmtCreateEnd: this.complaint.committime[1],
				'user_name': account.username,
				'cookie': account.cookie,
			}
			if (this.platform === 'TB') {
				data.entityPlatform = this.complaint.platform;
				data.entityType = 'item';
			}
			if (this.platform === 'JD') {
				data.page = '';
				data.entityPlatform = 'jd';
				data.getAllResult = 'true';
			}
			if (this.platform === 'DY') {
				data.page = '';
				data.entityPlatform = 'dy';
				data.getAllResult = 'true';
			}
			if (this.platform === 'PDD') {
				data.getAllResult = 'true';
				data.pageNum = 0;
				data.entityPlatform = 'pdd';
			}
			if (this.platform === 'SN') {
				data.entityPlatform = 'suning';
			}
			if (this.platform === 'SN') {
				data.page = '';
				data.entityPlatform = 'sn';
				data.getAllResult = 'true';
			}
			
			this.hcmBrmlogSave('complaintsexcel')
			fetch({
				url: this.getRequestUrl(),
				method: 'post',
				data: JSON.stringify(data),
				timeout: 60000000 * 1000
			}).then(res => {
				this.onCommitLoading = false
				if (Array.isArray(res.data) && res.data[0] === '获取数据失败,cookie失效') {
					this.$message.warning('cookie失效,请更新cookie');
				}
				if (res.total === '0') {
					this.$message.warning('已选日期范围内无投诉数据!');
					return;
				}
				if (res.success === 'True') {
					this.$message.success('已将此任务加入到下载列表中,请前往下载列表查看');
				}
			}).catch(res2 => {
				this.onCommitLoading = false
				this.$message.error('参数错误');
				return;
			})
		},
		hcmBrmlogSave(data) {
			let that = this;
			let datas = {
				modlename: data
			};
			fetch({
				url: "hcm/hcmBrmlog/save",
				method: "post",
				data: datas,
				noFormat: true,
				responseType: "text"
			}).then(res => {
				let result = JSON.parse(res);
				if (result.status == "10000") {

				}
			});
		},
		onDeleteAccount() {
			if (!this.complaint.account) {
				this.$message.error('请选择账号');
				return;
			}
			fetch({
				url: "hcm/complaiont/delete",
				method: "post",
				data: {
					ids: this.complaint.account,
					platform: this.platform === 'TB' ? 'AL' : this.platform
				}
			}).then(res => {
				if (res.status === '10000') {
					this.$message.success('删除成功');
					this.visible = false;
					this.complaint.account = '';
					this.load();
				}
			})
		},
		onCommitAccount() {
			this.$refs['cookie'].validate((valid) => {
				if (valid) {
					let data = {
						title: this.cookie.title.trim(),
						username: this.cookie.username.trim(),
						cookie: this.cookie.cookie.trim(),
						password: this.cookie.password.trim(),
						platform: this.platform === 'TB' ? 'AL' : this.platform
					}
					if (this.isEdit) {
						data.id = this.complaint.account;
					}
					fetch({
						url: "hcm/complaiont/save",
						method: "post",
						data
					}).then(res => {
						if (res.status === '10902') {
							this.$message.error(res.message);
						}
						if (res.status === '10000') {
							this.addOrUpdateCookieDialog = false;
							this.$message.success(this.isEdit ? '编辑成功' : '添加成功');
							this.load();
						}
					})
				}
			})
		},
		onEditOrAddAccount(type) {
			if (type === 1) {
				if (!this.complaint.account) {
					this.$message.error('请选择账号');
					return;
				}
				let item = this.accounts.find(account => {
					return account.id === this.complaint.account;
				});
				this.cookie = JSON.parse(JSON.stringify(item));
				this.isEdit = true;
			} else {
				this.cookie = {};
				this.isEdit = false;
			}
			this.addOrUpdateCookieDialog = true;
		},
		getComplaintTitle() {
			if (this.platform === 'TB') {
				return '阿里知产投诉报表';
			} else if (this.platform === 'PDD') {
				return '拼多多知产投诉报表';
			} else if (this.platform === 'SN') {
				return '苏宁知产投诉报表';
			} else if (this.platform === 'JD') {
				return '京东知产投诉报表';
			} else {
				return '抖音知产投诉报表';
			}
		},
		getComplaintExpire() {
			if (this.platform === 'TB') {
				return '阿里知识产权平台cookie有效期7天';
			} else if (this.platform === 'PDD') {
				return '拼多多知识产权平台cookie有效期4小时';
			} else if (this.platform === 'SN') {
				return '苏宁知识产权平台cookie有效期1天';
			} else if (this.platform === 'JD') {
				return '京东知识产权平台cookie有效期1天';
			} else {
				return '抖音知识产权平台cookie有效期4小时';
			}
		},
		load() {
			fetch({
				url: "hcm/complaiont/getListByBmcid",
				method: "get",
				params: {
					platform: this.platform === 'TB' ? 'AL' : this.platform
				}
			}).then(res => {
				if (res.status === '10000') {
					this.accounts = res.data;
				}
			})
		}
	},

	computed: {},

	created() {
		this.load();
	},

	mounted() { },
}
</script>


<style lang='scss'>
@import "style/activityApprovalSetting.scss";

.el-radio__input.is-checked+.el-radio__label {
	color: #bfa569;
}

.el-radio__input.is-checked .el-radio__inner {
	border-color: #bfa569;
	background: #bfa569;
}

.complaint-hint-box {
	display: flex;
	justify-content: center;
	align-items: center;

	.complaint-hint-icon {
		display: inline-block;
		margin-right: 20px;
		font-size: 30px;
		color: #e6a23c;
	}
}

.complaint-alert {
	display: inline-block;
	margin-left: 15px;
	width: 400px;
	height: 20px;
	background-color: #f2eeed;
	color: #e6a23c;

	.complaint-alert-icon {
		font-size: 16px;
	}
}

.complaint-box {
	background-color: #fff;
	padding: 20px;

	.complaint-box-btn {
		display: inline-block;
		margin-left: 20px;
		color: #409eff;
		cursor: pointer;
	}

	.complaint-box-dbtn {
		display: inline-block;
		margin-left: 20px;
	}
}
</style>
